export default class MapSettings {
  public static LONGITUDE_MAX_VALUE = 180;
  public static LONGITUDE_MIN_VALUE = -180;
  public static LATITUDE_MAX_VALUE = 90;
  public static LATITUDE_MIN_VALUE = -90;
  public static SMALL_MARKER_SIZE = 32;
  public static MEDIUM_MARKER_SIZE = 44;
  public static BIG_MARKER_SIZE = 56;
  public static MEDIUM_MARKER_COUNT = 25; // TODO: 1500
  public static BIG_MARKER_COUNT = 50; // TODO: 3000
  public static PROJECT_MARKER_ICON_COLOR = '#6249E2';
  public static PROJECT_MARKER_ICON_URL = 'assets/icons/icon-shadowed-project.svg';
  public static COMMUNITY_MARKER_ICON_COLOR = '#8C4AF0';
  public static COMMUNITY_MARKER_ICON_URL = 'assets/icons/icon-shadowed-community.svg';
  public static ORGANIZATION_MARKER_ICON_COLOR = '#4BB74B';
  public static ORGANIZATION_MARKER_ICON_URL = 'assets/icons/icon-shadowed-organization.svg';
  public static DOCTOR_MARKER_ICON_COLOR = '#50C29C';
  public static DOCTOR_MARKER_ICON_URL = 'assets/icons/icon-shadowed-doctor.svg';
  public static MED_STAFF_MARKER_ICON_COLOR = '#2E9EB1';
  public static MED_STAFF_MARKER_ICON_URL = 'assets/icons/icon-shadowed-medstaff.svg';
  public static PATIENT_MARKER_ICON_COLOR = '#00BAEC';
  public static PATIENT_MARKER_ICON_URL = 'assets/icons/icon-shadowed-patient.svg';
  public static RESEARCHER_MARKER_ICON_COLOR = '#3684F4';
  public static RESEARCHER_MARKER_ICON_URL = 'assets/icons/icon-shadowed-researcher.svg';
  public static INITIAL_MAP_ZOOM = 6;
  public static DEFAULT_MAP_ZOOM = 7;

  public static MAP_SEARCH_CONTINENT_ZOOM_MIN_LEVEL = 3;
  public static MAP_SEARCH_COUNTRY_ZOOM_MIN_LEVEL = 4;
  public static MAP_SEARCH_REGION_ZOOM_MIN_LEVEL = 5;
  public static MAP_SEARCH_SUBREGION_ZOOM_MIN_LEVEL = 7;
  public static MAP_SEARCH_INDIVIDUAL_ZOOM_MIN_LEVEL = 9;
  public static MAP_MAX_ZOOM_LEVEL = 18;
  public static MAP_MIN_ZOOM_LEVEL = 1;

  public static GOOGLE_MAPS_EARTH_MEAN_RADIUS_IN_METER = 6378137;
  public static DEG_TO_RAD: number = Math.PI / 180.0;
  public static THREE_PI: number = Math.PI * 3;
  public static TWO_PI: number = Math.PI * 2;
  public static USER_ENTITY_KIND = 'User';
  public static MAP_SEARCH_CITY_ZOOM_LEVEL_RADIUS = 4150;
  public static AGGREGATED_RADIUS_STEP = 500;
  public static AGGREGATED_INITIAL_RADIUS = 10000;
  public static AGGREGATED_RADIUS_MIDDLE_ZOOM = 6;
  public static PEOPLE_TAB_NESTED_AGGREGATE_ATTR_NAME = 'individual_type';
  public static ORGANIZATION_TAB_NESTED_AGGREGATE_ATTR_NAME = 'organization_type';
  public static REFETCH_AGGREGATED_MARKERS_INTERVAL = 180000; // 3 minutes in milliseconds
  /**
   * @description It's approximately a 25 miles in meters that is a half of radius to
   *              search on the 9th zoom level. Was selected as the most optimized.
   */
  public static DEFAULT_MAX_DISTANCE_BETWEEN_TWO_POINTS = 40240;
}
